export const logoSize = 32;

const styles = (theme) => ({
  header: {
    textAlign: 'left',
    boxShadow: 'none',
    padding: '18px 16px 0',
    borderBottom: '1px solid #dedede',

    '@supports (padding-top: env(safe-area-inset-top))': {
      paddingTop: 'max(env(safe-area-inset-top), 18px)',
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  contentText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  logoLoader: {
    flexShrink: 0,
    width: logoSize,
    height: logoSize,
    marginRight: '13px',
  },
  logo: {
    width: logoSize,
    height: logoSize,
    marginRight: '13px',
  },
  badge: {
    fontSize: '12px',
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.red,
  },
  notificationIcon: {
    width: '30px',
    height: '25px',
    fill: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  grow: {
    flexGrow: 1,
  },
});

export default styles;
